import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    exportLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    staffUserList: [],
    contestList: [],
    contestTotalCounts: 0
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const ContestReAssignSlice = createSlice({
    name: "contestsReAssign",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        reAssignedContestList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.contestTotalCounts = totalCount;
        },
        emptyList: (state, action) => {
            state.error = null;
            state.entities = [];
            // state.totalCount = 0;
            state.exportData = [];
        },
        staffUsersFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            // state.listLoading = false;
            state.error = null;
            state.staffUserList = entities;
            // state.totalCount = totalCount;
        },

        contestListList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.contestList = entities;
            // state.contestTotalCounts = totalCount;
        },
    }
})